import {
  Link,
  LinkProperties,
  Tooltip,
  Box,
  Icon,
} from '@nimbus-ds/components';
import { GenerativeStarsIcon } from '@nimbus-ds/icons';
import { AiFeature } from '@tiendanube/common';
import { useResponsive } from 'commons/components';
import { useTranslationCommon } from 'commons/hooks';
import { trackingAiGenerateCtaClick } from 'domains/Ai/tracking';

interface GenerateWithAiLinkProps {
  onClick: () => void;
  trackingFeature?: AiFeature;
  fontSize?: LinkProperties['fontSize'];
  disabled?: boolean;
  tooltipText?: string;
  tooltipMaxWidth?: string;
}
function GenerateWithAiLink({
  onClick,
  trackingFeature,
  fontSize = 'base',
  disabled = false,
  tooltipText,
  tooltipMaxWidth,
}: Readonly<GenerateWithAiLinkProps>) {
  const t = useTranslationCommon();
  const { isMobile } = useResponsive();
  const handleOnClick = () => {
    if (disabled) return;

    if (trackingFeature) {
      trackingAiGenerateCtaClick({ feature: trackingFeature });
    }
    onClick();
  };

  const linkComponent = (
    <Link
      as={disabled ? 'button' : 'a'}
      disabled={disabled}
      aria-disabled={disabled}
      appearance="primary"
      onClick={handleOnClick}
      textDecoration="none"
      fontSize={fontSize}
    >
      <Icon
        source={<GenerativeStarsIcon />}
        color={disabled ? 'neutral-textDisabled' : 'ai-generative'}
      />
      {t('aiGeneration.generateWithAI')}
    </Link>
  );

  if (disabled && tooltipText) {
    return (
      <Tooltip
        content={tooltipText}
        arrow
        position={isMobile ? 'top' : 'right'}
        maxWidth={tooltipMaxWidth}
      >
        <Box marginRight="1">{linkComponent}</Box>
      </Tooltip>
    );
  }

  return linkComponent;
}

export default GenerateWithAiLink;
